import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-085da17a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mobile-bottom-nav",
  "aria-label": "Bottom navigation"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "mobile-bottom-nav__item-content" }
const _hoisted_4 = { class: "mobile-bottom-nav__label" }

import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {
  CART,
  FAVOURITE,
  HOME,
  INFORM,
  ORDERS,
  PRODUCT_DETAIL,
  PRODUCTS,
  SIGN_IN,
} from '@/const/path'

interface NavItem {
  key: string
  path: string
  label: string
  icon: string
  iconActive: string
  match: (path: string) => boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuBottom',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const navItems: NavItem[] = [
  {
    key: 'home',
    path: HOME,
    label: 'menu.home',
    icon: 'fa-solid fa-house',
    iconActive: 'fa-solid fa-house',
    match: (path) => path === HOME || path === '',
  },
  {
    key: 'products',
    path: PRODUCTS,
    label: 'menu.products',
    icon: 'fa-solid fa-store',
    iconActive: 'fa-solid fa-store',
    match: (path) =>
      path.startsWith(PRODUCTS) || path.startsWith(PRODUCT_DETAIL),
  },
  {
    key: 'cart',
    path: CART,
    label: 'menu.cart',
    icon: 'fa-solid fa-cart-shopping',
    iconActive: 'fa-solid fa-cart-shopping',
    match: (path) => path.startsWith(CART) || path.startsWith(ORDERS),
  },
  {
    key: 'favourite',
    path: FAVOURITE,
    label: 'text.favourite',
    icon: 'fa-regular fa-heart',
    iconActive: 'fa-solid fa-heart',
    match: (path) => path.startsWith(FAVOURITE),
  },
  {
    key: 'user',
    path: INFORM,
    label: 'menu.user',
    icon: 'fa-regular fa-user',
    iconActive: 'fa-solid fa-user',
    match: (path) =>
      path.startsWith(INFORM) ||
      path.startsWith(SIGN_IN) ||
      path.startsWith('/sign-up'),
  },
]

const currentPath = computed(() => route.path || HOME)

const isActive = (item: NavItem) => item.match(currentPath.value)

const go = (path: string) => {
  if (route.path === path) return
  router.push({ path })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
      return _createElementVNode("button", {
        key: item.key,
        type: "button",
        class: _normalizeClass(["mobile-bottom-nav__item", { 'mobile-bottom-nav__item--active': isActive(item) }]),
        onClick: ($event: any) => (go(item.path))
      }, [
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("i", {
            class: _normalizeClass(isActive(item) ? item.iconActive : item.icon),
            "aria-hidden": "true"
          }, null, 2),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(item.label)), 1)
        ])
      ], 10, _hoisted_2)
    }), 64))
  ]))
}
}

})